<style scoped>
.parent {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  grid-template-rows: repeat(5, 1fr);
  gap: 8px;
}

.div1 {
  grid-column: span 3 / span 3;
  grid-row: span 5 / span 5;
}

.div2 {
  grid-column: span 3 / span 3;
  grid-row: span 4 / span 4;
  grid-column-start: 4;
}

.div3 {
  grid-column: span 3 / span 3;
  grid-column-start: 4;
  grid-row-start: 5;
}
</style>
<template>
  <div class="container-fluid">
    <div class="parent">
      <div class="div1">
        <div class="card">
          <div class="card-body">
            <div>
              <div>
                <div class="form-group row d-flex align-items-center">
                  <label
                    style="font-size: 14px"
                    class="col-form-label col-3 text-lg-right text-left"
                    >Enseignant permanent :</label
                  >
                  <div class="col-9 d-flex align-items-center">
                    <select
                      v-model="prof"
                      :disabled="isDisabled"
                      :class="{ disabled: isDisabled }"
                      data-width="100%"
                      class="selectpicker"
                      data-live-search="true"
                    >
                      <option
                        v-for="item in professeurs"
                        :key="item.id"
                        :value="item"
                      >
                        {{ item.agresso }} - {{ item.nom }} {{ item.prenom }}
                      </option>
                    </select>
                  </div>
                </div>
                <hr />
                <div class="form-group row">
                  <label class="col-form-label col-3 text-lg-right text-right">
                    Programme<span style="color: #ee2d41">* </span> :
                  </label>
                  <div class="col-9">
                    <div class="input-group input-group-lg input-group-solid">
                      <select
                        v-model="programme"
                        placeholder="Programme"
                        class="selectpicker"
                        data-width="100%"
                        data-live-search="true"
                      >
                        <option value="" disabled>Programme</option>
                        <option
                          style="color: #003667"
                          v-for="programme in programmes"
                          :key="programme.id"
                          :value="programme"
                        >
                          {{ programme.offre }} - {{ programme.code }} -
                          {{ programme.description }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-form-label col-3 text-lg-right text-right">
                    Volume horaire <span style="color: #ee2d41">* </span> :
                  </label>
                  <div class="col-9">
                    <div class="input-group input-group-lg input-group-solid">
                      <input
                        type="number"
                        class="form-control form-control-lg form-control-solid"
                        v-model="nb_heures"
                      />
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-form-label col-3 text-lg-right text-right">
                    Détail des activités :
                  </label>
                  <div class="col-9">
                    <textarea
                      cols="30"
                      rows="5"
                      class="form-control form-control-lg form-control-solid"
                      v-model="commentaire"
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>

            <div class="text-center">
              <button
                :disabled="!isFormValid()"
                @click="ajouter_detail()"
                type="button"
                class="btn btn-primary pl-10 pr-14 py-3"
              >
                Ajouter
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="div2">
        <div class="card">
          <div class="card-body">
            <table class="table">
              <thead style="background-color: #003667; color: white">
                <tr class="text-center">
                  <td>Enseignant permanent</td>
                  <td>Programme</td>
                  <td>Offre</td>
                  <td>Volume horaire</td>
                  <td>Détail des activités</td>
                  <td></td>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(detail, index) in details"
                  :key="detail.id"
                  class="text-center"
                >
                  <td>
                    {{ detail.professeur.nom }}
                    {{ detail.professeur.prenom }}
                  </td>
                  <td>{{ detail.programme.description }}</td>
                  <td>{{ detail.programme.offre }} - {{ detail.programme.code }}</td>
                  <td>{{ detail.vh }}</td>
                  <td>
                    {{ detail.commentaire }}
                  </td>
                  <td>
                    <button class="btn btn-icon" @click="deleteDetail(index)">
                      <i
                        class="fa fa-times"
                        aria-hidden="true"
                        style="color: #f64e60"
                      ></i>
                    </button>
                  </td>
                </tr>
              </tbody>
              <tfoot v-if="totalHeures() > 0">
                <tr class="text-center">
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>Total : {{ totalHeures() }}</td>
                  <td></td>
                  <td></td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
      <div class="div3 text-center">
        <button
          v-if="totalHeures() > 0"
          @click="valide_declaration()"
          :disabled="isSubmitting"
          type="button"
          class="btn btn-success pl-10 pr-14 py-3"
        >
          <span class="svg-icon svg-icon-white svg-icon-success svg-icon-2x">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              width="24px"
              height="24px"
              viewBox="0 0 24 24"
              version="1.1"
            >
              <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <polygon points="0 0 24 0 24 24 0 24" />
                <path
                  d="M9.26193932,16.6476484 C8.90425297,17.0684559 8.27315905,17.1196257 7.85235158,16.7619393 C7.43154411,16.404253 7.38037434,15.773159 7.73806068,15.3523516 L16.2380607,5.35235158 C16.6013618,4.92493855 17.2451015,4.87991302 17.6643638,5.25259068 L22.1643638,9.25259068 C22.5771466,9.6195087 22.6143273,10.2515811 22.2474093,10.6643638 C21.8804913,11.0771466 21.2484189,11.1143273 20.8356362,10.7474093 L17.0997854,7.42665306 L9.26193932,16.6476484 Z"
                  fill="#000000"
                  fill-rule="nonzero"
                  opacity="0.3"
                  transform="translate(14.999995, 11.000002) rotate(-180.000000) translate(-14.999995, -11.000002) "
                />
                <path
                  d="M4.26193932,17.6476484 C3.90425297,18.0684559 3.27315905,18.1196257 2.85235158,17.7619393 C2.43154411,17.404253 2.38037434,16.773159 2.73806068,16.3523516 L11.2380607,6.35235158 C11.6013618,5.92493855 12.2451015,5.87991302 12.6643638,6.25259068 L17.1643638,10.2525907 C17.5771466,10.6195087 17.6143273,11.2515811 17.2474093,11.6643638 C16.8804913,12.0771466 16.2484189,12.1143273 15.8356362,11.7474093 L12.0997854,8.42665306 L4.26193932,17.6476484 Z"
                  fill="#000000"
                  fill-rule="nonzero"
                  transform="translate(9.999995, 12.000002) rotate(-180.000000) translate(-9.999995, -12.000002) "
                />
              </g>
            </svg>
          </span>
          Valider
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { VclTable } from "vue-content-loading";
export default {
  props: {
    admin: {},
  },
  components: {
    VclTable,
  },

  data() {
    return {
      programmes: [],
      professeurs: [],
      prof: [],
      details: [],
      professeur: {},
      keyword: null,
      search: null,
      nb_heures_old: null,
      nb_heures: null,
      programme: null,
      commentaire: null,
      profNotFound: false,
      disableValideBtn: false,
      isDisabled: false,
      isSubmitting: false,
      config: {
        headers: {
          Authorization: "Bearer " + this.admin.api_token,
        },
      },
    };
  },
  watch: {},

  methods: {
    totalHeures() {
      return this.details.reduce((sum, detail) => {
        return sum + Number(detail.vh || 0);
      }, 0);
    },

    isFormValid() {
      return (
        this.prof !== null &&
        this.programme !== null &&
        this.nb_heures !== null &&
        this.nb_heures !== ""
      );
    },
    valide_declaration() {
      this.isSubmitting = true;
      axios
        .post(
          "/api/create/declaration",
          {
            details: this.details,
            prof_id: this.prof.id,
          },
          this.config
        )
        .then((res) => {
          window.location.href = "/administration/declaration-vh-fc/index";

          Vue.swal.fire({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 5000,
            title: "Déclaration ajoutée avec succès",
            icon: "success",
            confirmButtonText: "Cool",
          });
        })
        .catch((error) => {
          let message = "Erreur dans l'ajout du déclaration";
          if (error.response && error.response.data.message) {
            message = error.response.data.message;
          }

          Vue.swal.fire({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 50000,
            title: message,
            icon: "error",
            confirmButtonText: "Cool",
          });
        })
        .finally(() => {
          this.isSubmitting = false;
        });
    },
    ajouter_detail() {
      var detail = {
        professeur: this.prof,
        programme: this.programme,
        vh: this.nb_heures,
        commentaire: this.commentaire,
      };

      this.details.push(detail);
      this.isDisabled = true;

      this.programme = null;
      this.nb_heures = null;
      this.commentaire = null;
    },
    loadProfesseurs() {
      axios.get("/api/get/professeurs", this.config).then((res) => {
        this.professeurs = res.data;

        this.$nextTick(() => {
          $(".selectpicker").selectpicker("refresh"); // refresh after data load
        });
      });
    },

    deleteDetail(index) {
      this.details.splice(index, 1);
    },
  },
  mounted() {
    $(".selectpicker").selectpicker(); // initialize on mount
    this.loadProfesseurs();
  },
  created() {
    axios
      .get("/api/get/programmesFC/" + this.admin.id, this.config)
      .then((res) => {
        this.programmes = res.data;
      });
  },
};
</script>
